import { useContext } from 'react';
import SignInContext from '@modules/users/contexts/SignInContext.context';

export const useProjectsSettings = () => {
  const { organization } = useContext(SignInContext);
  const settings = organization.featureSettings.projects;
  const enabled = Boolean(settings?.enabled && settings.enabledRootItemTypes?.length);
  return {
    enabled,
    enabledRootItemTypes: settings?.enabledRootItemTypes,
  };
};
